import { safeLocalStorage } from "./safeLocalStorage";

const recaptchaLangDict = {
  en: "en",
  ru: "ru",
  ua: "uk",
  az: "az",
  by: "ru",
  ge: "ka",
  kg: "ru",
  kz: "ru",
  ee: "et",
  lt: "lt",
  lv: "lv"
};

const setItem = (key, value) => {
  if (key === "lang") {
    window.recaptchaOptions = {
      lang: recaptchaLangDict[value] || "ru"
    };
  }

  safeLocalStorage.setItem(key, value);
};
const getItem = key => {
  let value = safeLocalStorage.getItem(key);

  if (key === "lang" && !value) {
    value = "ru";
  }

  return value;
};

export default {
  setItem,
  getItem
};
